import React from 'react';
import Icon from '../../../components/AppIcon';

/** Read-only list of current directors (DIN, name, since) fetched from MCA. */
const DirectorsList = ({ directors = [], cin }) => {
  if (!directors.length) return null;
  return (
    <div className="md:col-span-2 overflow-hidden rounded-lg border border-success/30">
      <div className="flex flex-wrap items-center justify-between gap-2 bg-success/5 px-4 py-2">
        <p className="flex items-center gap-2 text-sm font-semibold text-foreground">
          <Icon name="Users" size={16} className="text-success" /> Current directors
        </p>
        <p className="flex items-center gap-1 text-xs text-text-secondary">
          <Icon name="Lock" size={12} className="text-success" /> From MCA records{cin ? ` · ${cin}` : ''}
        </p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-muted/40 text-xs uppercase tracking-wide text-text-secondary">
            <tr>
              <th className="px-4 py-2 text-left font-medium">DIN</th>
              <th className="px-4 py-2 text-left font-medium">Name</th>
              <th className="px-4 py-2 text-left font-medium">Since</th>
            </tr>
          </thead>
          <tbody>
            {directors.map((d) => (
              <tr key={d.din} className="border-t border-border">
                <td className="px-4 py-2 font-mono tabular-nums">{d.din}</td>
                <td className="px-4 py-2">{d.name}</td>
                <td className="px-4 py-2 text-text-secondary">{d.since || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DirectorsList;
